import { last, size, keys } from "lodash";
import { createSelector } from "reselect";

import { getSurveyQuestionnaire } from "state/modules/survey/selectors";
export {
  getSurveyLogo,
  getSurveyBackground,
  getSurveyQuestionnaire,
} from "state/modules/survey/selectors";
import { FILE_TYPE } from "consts";

export const getSection = state => last(state.navigation.sectionStack);

export const getSequence = state => size(state.navigation.sectionStack);

export const getLanguageKey = state => state.response.lang;

export const getHeadingKey = state => state.response.headingKey;

export const getIsRTL = state => state.response.lang === "text_urdu";

export const getIsValid = state => state.response.canMoveForward;

export const selectDivision = state => state.division;

export const selectAllDivisions = state => state.organization.divisions;

export const selectDivisionInfo = state => state.survey.divisionInfo;

export const getSelectedOptions = createSelector(
  state => state.response.questions,
  (_, question) => question,
  (questionResponse, question) => {
    if (question.is_master_question) {
      return questionResponse;
    }
    return questionResponse[question.virtual_id]?.options;
  },
);

export const getSelectedQuestionOptions = createSelector(
  getSelectedOptions,
  (_, question) => question,
  (selectedOptions, question) => {
    if (question.is_master_question) {
      return selectedOptions;
    }
    return keys(selectedOptions || {})
      .map(id => parseInt(id, 10))
      .filter(id => id || id === 0)
      .map(id => question.options.find(o => o.virtual_id === id));
  },
);

export const selectUploadedMedia = createSelector(
  getSelectedOptions,
  (_state, _question, option) => option,
  (_state, _question, _option, subOption) => subOption,
  (selectedOptions, option, subOption) => {
    let selectedOption = selectedOptions?.[option.virtual_id];
    if (subOption) {
      selectedOption = selectedOption?.subOptions?.[subOption.virtual_id];
    }

    const files = selectedOption?.files || [];

    const mediaFiles = files.filter(
      file => file.type === FILE_TYPE.IMAGE || file.type === FILE_TYPE.VIDEO,
    );

    const audioFiles = files.filter(file => file.type === FILE_TYPE.AUDIO);
    const audioFile = audioFiles.length ? audioFiles[0] : {};

    return { mediaFiles, audioFile };
  },
);

export const getOptionError = (state, option) =>
  state.response.errors[option.id];

export const getSurveyCompletionPercentage = state => {
  const questionnaire = getSurveyQuestionnaire(state);
  if (!questionnaire) {
    return 0;
  }
  const totalSections = questionnaire.questionnaire_sections.length;
  const currentSectionIndex = state.navigation.currentSectionIndex;
  const percentage = (currentSectionIndex / totalSections) * 100;
  return parseInt(percentage, 10);
};

export const getDrilledDownSubHeading = question => {
  const isSingleSelection = question.max_sub_option_selection_count === 1;
  return question.max_sub_option_selection_count
    ? `Please select ${question.max_sub_option_selection_count} option${
        isSingleSelection ? "" : "s"
      } for each section`
    : "Please select all that apply";
};
